module.exports = __webpack_public_path__ + "static/img/banner-empleo-home-500x750.4933914.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banners/banner-empleo-home-500x750.jpg
// module id = K9n4
// module chunks = 47